// Catálogo de los sistemas del "lobby" de la DIN (vista `/elegir-sistema`).
// Fuente ÚNICA de verdad, compartida por:
//   - la vista cliente `app/(auth)/elegir-sistema/page.tsx`
//   - el middleware server-side `proxy.ts` (mapea la cookie `host` → key)
// Es dato plano: NO debe tener 'use client' ni importar nada de cliente, para
// poder importarse también desde el runtime del middleware.

export type SistemaKey = 'siiv' | 'postulaciones' | 'incentivos';

export interface Sistema {
	key: SistemaKey;
	nombre: string;
	descripcion: string;
	// Destino al "Continuar":
	//   - `href`: ruta interna (solo SIIV, este mismo sistema).
	//   - `url`:  URL absoluta de otro sistema DIN. Vive en env porque cambiará
	//             con el dominio/SSL definitivo; hoy sin valor → no navegable en local.
	href?: string;
	url?: string;
	// Host productivo (para traducir la cookie cross-system `host` → key en prod).
	// Se moverá a env junto con el dominio definitivo (R09/R10). En local no se usa:
	// el origen llega por `?from=`.
	host?: string;
	disponible: boolean;
}

export const SISTEMAS: Sistema[] = [
	{
		key: 'siiv',
		nombre: 'InvestigaUDA',
		descripcion: 'Información de investigación y postgrado',
		href: '/',
		host: 'investiga.uda.cl',
		disponible: true,
	},
	{
		key: 'postulaciones',
		nombre: 'Postulaciones',
		descripcion: 'Postulación a concursos y convocatorias',
		url: process.env.NEXT_PUBLIC_POSTULACIONES_URL || undefined,
		host: 'postulaciones.vrip.uda.cl',
		disponible: Boolean(process.env.NEXT_PUBLIC_POSTULACIONES_URL),
	},
	{
		key: 'incentivos',
		nombre: 'Incentivos',
		descripcion: 'Incentivos a la productividad científica',
		url: process.env.NEXT_PUBLIC_INCENTIVOS_URL || undefined,
		disponible: Boolean(process.env.NEXT_PUBLIC_INCENTIVOS_URL),
	},
];

export const DEFAULT_ORIGIN: SistemaKey = 'siiv';

export function getSistema(key: string | null | undefined): Sistema | undefined {
	return SISTEMAS.find((s) => s.key === key);
}

/**
 * Traduce el host de la cookie cross-system (`host`) a la key del sistema.
 * Solo se usa server-side (middleware) en producción; en local el origen llega
 * por `?from=` y este map no interviene. Host desconocido → undefined (no-op seguro).
 */
export function hostToSistemaKey(host: string | null | undefined): SistemaKey | undefined {
	if (!host) return undefined;
	const normalized = host.trim().toLowerCase();
	return SISTEMAS.find((s) => s.host && s.host.toLowerCase() === normalized)?.key;
}
